import { useState } from "react";
import { Box, Button, Stack } from "@mui/material";
import MentalWellbeingModal from "./index";

export default function MentalWellbeingModalExamples() {
  const [controlledOpen, setControlledOpen] = useState(false);

  return (
    <Stack spacing={3}>
      <Box>
        <MentalWellbeingModal />
      </Box>
      <Box>
        <Button
          variant="outlined"
          onClick={() => setControlledOpen(true)}
          aria-label="Open mental wellbeing modal"
        >
          Open modal (controlled)
        </Button>
        <MentalWellbeingModal
          isOpen={controlledOpen}
          onClose={() => setControlledOpen(false)}
        />
      </Box>
    </Stack>
  );
}
